<template>
  <form @submit.prevent="$emit('submit')">
    <div class="form-group">
      <label for="bug-description">What happened? *</label>
      <textarea 
        id="bug-description"
        :value="bugReport.description"
        @input="updateField('description', $event.target.value)"
        placeholder="Describe what you were trying to do when the bug occurred..."
        required
        rows="4"
      ></textarea>
    </div>

    <div class="form-group">
      <label for="bug-steps">Steps to reproduce (optional)</label>
      <textarea 
        id="bug-steps"
        :value="bugReport.steps"
        @input="updateField('steps', $event.target.value)"
        placeholder="1. First I clicked...&#10;2. Then I..."
        rows="3"
      ></textarea>
    </div>

    <div class="form-group">
      <label for="bug-priority">Priority</label>
      <select 
        id="bug-priority" 
        :value="bugReport.priority"
        @change="updateField('priority', $event.target.value)"
      >
        <option value="low">Low</option>
        <option value="medium">Medium</option>
        <option value="high">High</option>
        <option value="critical">Critical</option>
      </select>
    </div>

    <DataPreview 
      :console-log-count="consoleLogCount"
      :network-call-count="networkCallCount"
    />

    <div class="form-actions">
      <button type="button" @click="$emit('cancel')" class="btn-cancel">
        Cancel
      </button>
      <button type="submit" class="btn-submit" :disabled="isSubmitting">
        {{ isSubmitting ? 'Sending...' : 'Send Bug Report' }}
      </button>
    </div>
  </form>
</template>

<script>
import DataPreview from './DataPreview.vue'

export default {
  name: 'BugReportForm',
  
  components: {
    DataPreview
  },
  
  props: {
    bugReport: {
      type: Object,
      required: true
    },
    consoleLogCount: {
      type: Number,
      default: 0
    },
    networkCallCount: {
      type: Number,
      default: 0
    },
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  
  emits: ['submit', 'cancel', 'update-field'],
  
  methods: {
    updateField(field, value) {
      this.$emit('update-field', { field, value })
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #374151;
  font-size: 14px;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.btn-cancel,
.btn-submit {
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.btn-cancel {
  background: #f3f4f6;
  color: #374151;
}

.btn-cancel:hover {
  background: #e5e7eb;
}

.btn-submit {
  background: #3b82f6;
  color: white;
}

.btn-submit:hover:not(:disabled) {
  background: #2563eb;
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 640px) {
  .form-actions {
    flex-direction: column;
  }
  
  .btn-cancel,
  .btn-submit {
    width: 100%;
  }
}
</style>